import { Badge, styled } from "@mui/material";
import { PickersDay } from "@mui/x-date-pickers";
import dayjs from 'dayjs';

export const badge = (props) => {
    const { highlightedDays = [], day, initialEventDate, outsideCurrentMonth, ...other } = props;
    // const eventSelected = !props.outsideCurrentMonth && initialEventDate.findIndex((date) => dayjs(date).isSame(props.day)) >= 0

    const isSelected = !props.outsideCurrentMonth && highlightedDays.findIndex((date) => dayjs(date).isSame(props.day)) >= 0;

    return (
      <MuiBadgeCust
        key={props.day.toString()}
        overlap="circular"
        badgeContent={isSelected && !props.selected ? <Dot /> : undefined}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
      >
      <PickersDay sx={{ "&.Mui-selected": { background: isSelected ? f_clr.ctaPrimary : '#fff'},
        "&:hover": {
          background: isSelected ? f_clr.ctaPrimary : "#fff", // customize
        },
        "&.Mui-selected:focus": {
          background: isSelected ? f_clr.ctaPrimary : "#fff", // customize
        }, fontSize: "16px", fontFamily: "Cerebri sans", fontWeight: "500", color: '#000' }} {...other} outsideCurrentMonth={outsideCurrentMonth} day={day} />
      </MuiBadgeCust>
    );
  }

  const Dot = styled('div')(
    ({ }) => ({
      width: "4px",
      height: "4px",
      borderRadius: "50%",
      background: f_clr.ctaPrimary,
    }),
  );

  const MuiBadgeCust = styled(Badge)(() => ({
    "& .MuiBadge-badge": {
      right: "49%",
      bottom: "5px",
      width: "4px",
      height: "4px",
    }
 }));
 